import { SERVER_API_URL } from "../constants/constants";
import axios from "axios";

const uploaddocument = async (formdata) => {
  try {
    const url = `${SERVER_API_URL}/admin/verify_document/uploaddocument`;
    const response = await axios.post(url, formdata);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getalldocument = async (page, searchTerm = '', status = '', type = '', limit = 10) => {
  try {
    const getToken = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${getToken}` },
      params: {
        page,
        limit,
        searchTerm,
        status,
        type
      }
    };
    const url = `${SERVER_API_URL}/verification/admin/verification-requests`;

    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const reviewVerificationRequest = async (requestId, status, rejection_reason = "") => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  const url = `${SERVER_API_URL}/verification/admin/review-request`;

  const result = await axios.post(url, {
    requestId,
    status,
    rejection_reason
  }, config);
  return result.data;
};

const undoApproval = async (requestId) => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  const url = `${SERVER_API_URL}/verification/admin/undo-approval`;

  const result = await axios.post(url, { requestId }, config);
  return result.data;
};

export {
  uploaddocument,
  getalldocument,
  reviewVerificationRequest,
  undoApproval
}